/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { AccessEnrollmentProgressionRequestFlowName } from "./AccessEnrollmentProgressionRequestFlowName";
import type { BaseProgressionMetadata } from "./BaseProgressionMetadata";

/**
 * Enrollment into one of the CMS ACCESS tracks.
 *
 * One flow per track, so a user can progress and resume each track independently; the steps are
 * identical and only the key differs.
 */
export interface AccessEnrollmentProgressionRequest {
  /** The conversation this progression operates within, if one exists */
  conversation_id?: string | null;
  /** The clinic request this progression serves, which scopes it: entering the flow via a different request gets a different progression. */
  clinic_request_id?: string | null;
  flow_name: AccessEnrollmentProgressionRequestFlowName;
  metadata?: BaseProgressionMetadata | null;
}
